import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const dynamicFormApi = createApi({
  reducerPath: 'dynamicFormApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    validateSlug: builder.query<
      { valid: boolean },
      { slug: string; templateId?: string }
    >({
      query: ({ slug, templateId }) => {
        const params = templateId ? `?template_id=${templateId}` : '';
        return `internal/v1/dynamic_form_templates/validate_slug/${slug}${params}`;
      },
    }),
  }),
});

export const { useLazyValidateSlugQuery } = dynamicFormApi;
